var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "text-center mb-6" }, [
        _vm._v(_vm._s(_vm.$t("roomWizard.selectLanguage")))
      ]),
      _c("v-autocomplete", {
        staticClass: "mb-4",
        attrs: {
          outlined: "",
          loading: _vm.loading,
          clearable: "",
          label: _vm.$t("roomWizard.language"),
          items: _vm.languagesOptions,
          "item-value": "value",
          "item-text": "text",
          "hide-details": "auto"
        },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("v-img", {
                  staticClass: "mr-2",
                  attrs: { "max-width": "20", src: item.icon }
                }),
                _vm._v(" " + _vm._s(item.text) + " ")
              ]
            }
          },
          {
            key: "item",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("v-img", {
                  staticClass: "mr-2",
                  attrs: { "max-width": "20", src: item.icon }
                }),
                _vm._v(" " + _vm._s(item.text) + " ")
              ]
            }
          }
        ]),
        model: {
          value: _vm.language,
          callback: function($$v) {
            _vm.language = $$v
          },
          expression: "language"
        }
      }),
      _c("v-autocomplete", {
        attrs: {
          outlined: "",
          loading: _vm.loading,
          clearable: "",
          label: _vm.$t("roomWizard.timezone"),
          items: _vm.timezoneOptione,
          "item-value": "value",
          "item-text": "text",
          "hide-details": "auto"
        },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function(ref) {
              var item = ref.item
              return [_c("span", [_vm._v(_vm._s(item.text))])]
            }
          },
          {
            key: "item",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("div", { staticClass: "py-1" }, [
                  _c("strong", { staticClass: "d-block" }, [
                    _vm._v(_vm._s(item.text))
                  ]),
                  _c(
                    "div",
                    { staticClass: "text-caption" },
                    [
                      _vm._v(" " + _vm._s(item.value)),
                      _vm._l(item.utc, function(u) {
                        return _c("span", { key: u }, [
                          _vm._v(" - " + _vm._s(u))
                        ])
                      })
                    ],
                    2
                  )
                ])
              ]
            }
          }
        ]),
        model: {
          value: _vm.timezone,
          callback: function($$v) {
            _vm.timezone = $$v
          },
          expression: "timezone"
        }
      }),
      _c(
        "div",
        { staticClass: "d-flex justify-space-between my-8" },
        [
          !_vm.first
            ? _c("va-button", {
                staticClass: "mr-4",
                attrs: {
                  color: "secondary",
                  type: "outline",
                  cta: _vm.$t("roomWizard.prev")
                },
                on: { click: _vm.onBack }
              })
            : _c("v-spacer"),
          _c("va-button", {
            attrs: {
              disabled: _vm.language == undefined || _vm.timezone == undefined,
              loading: _vm.loading,
              cta: _vm.$t("roomWizard.next")
            },
            on: { click: _vm.onFinish }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }